import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../components/lib/withRouter';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { exportToExcel } from '../../utils/excelExport';
import { getBranchesLatest } from '../../store/actions';

class SectionWiseExamAnalysisReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exams: [],
            selectedExam: null,
            selectedBranches: [],
            selectedSections: [],
            filteredData: [],
            rawData: [],
            dataTableKey: 0,
            tableLoading: false,
            sectionsData: [],
            sectionBranchLinks: [], // Add this new state
        };
        this.service = new Service();
    }

    componentDidMount() {
        // this.props.getBranchesLatest(true);
        this.fetchSectionBranchLinks();
    }

    fetchSectionBranchLinks = () => {
        this.setState({ tableLoading: true });

        this.service.post(`${baseUrlAdmin}/branch/sectionsByOrgAndYear`, {
            academicYear: localStorage.getItem('userAcademicYear'),
            orgId: localStorage.getItem('orgId')
        }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    this.setState({
                        sectionBranchLinks: response.res.data,
                        tableLoading: false
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching section-branch links:', error);
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch section data',
                    life: 3000
                });
            });
    }

    onBranchesChange = (selectedBranches) => {
        if (selectedBranches && selectedBranches.length > 0) {
            // Filter sections based on selected branches using sectionBranchLinks
            const sectionsMap = new Map();
            
            this.state.sectionBranchLinks
                .filter(link => selectedBranches.includes(link._id))
                .forEach(branch => {
                    branch.sections.forEach(section => {
                        // Create unique key combining branchId and sectionId
                        const uniqueKey = `${branch._id}_${section.sectionId}`;
                        
                        // Only add if this unique combination doesn't exist
                        if (!sectionsMap.has(uniqueKey)) {
                            sectionsMap.set(uniqueKey, {
                                key: uniqueKey,
                                sectionId: section.sectionId,
                                name: `${section.className}--${section.sectionName}`,
                                branchId: branch._id,
                                branchName: branch.branchName
                            });
                        }
                    });
                });

            const sections = Array.from(sectionsMap.values());

            this.setState({
                selectedBranches,
                sectionsData: sections,
                selectedSections: [],
                selectedExam: null,
                exams: [],
                filteredData: [],
                rawData: []
            }, () => {
                this.getSectionWiseExamAnalysisReport();
            });
        } else {
            this.setState({
                selectedBranches: [],
                sectionsData: [],
                selectedSections: [],
                selectedExam: null,
                exams: [],
                filteredData: [],
                rawData: []
            });
        }
    };

    onSectionsChange = (selectedSections) => {
        if (selectedSections && selectedSections.length > 0) {
            this.setState({
                selectedSections,
                selectedExam: null,
                filteredData: []
            }, () => {
                this.getSectionWiseExamAnalysisReport();
            });
        } else {
            // Handle deselection - clear all dependent data
            this.setState({
                selectedSections: [],
                selectedExam: null,
                exams: [],
                filteredData: [],
                rawData: []
            });
        }
    };

    getSectionWiseExamAnalysisReport() {
        const { selectedBranches, selectedSections } = this.state;

        if (!selectedSections || !selectedSections.length || !selectedBranches || !selectedBranches.length) {
            return;
        }

        this.setState({ tableLoading: true });

        // Extract actual section IDs from the unique keys (format: branchId_sectionId)
        const sectionIds = selectedSections.map(uniqueKey => {
            const parts = uniqueKey.split('_');
            return parts[1]; // Return the sectionId part
        });

        this.service.post(`${baseUrlAdmin}/academicsReports/sectionWiseExamAnalysisReport`, {
            academicYear: localStorage.getItem('userAcademicYear'),
            branchIds: selectedBranches,
            sectionIds: sectionIds
        }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const exams = response.res.data.map(item => ({
                        examId: item.examId,
                        examName: item.examName
                    })).filter((exam, index, self) =>
                        index === self.findIndex((e) => e.examId === exam.examId)
                    );

                    this.setState({
                        rawData: response.res.data,
                        exams,
                        tableLoading: false,
                        selectedExam: null,
                        filteredData: []
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch data',
                    life: 3000
                });
            });
    }

    processData(data) {
        if (!data.length) return { columns: [], data: [] };

        // Create columns based on sections
        const columns = data.map(section => ({
            field: section.sectionId,
            header: `${section.branchName}--${section.className}--${section.sectionName}`
        }));

        const processedData = [];
        const parameters = [
            'Total No of Students',
            'Total Present',
            'Section Highest',
            'Section Least',
            'Section Average'
        ];

        // Add Overall Analysis header row
        processedData.push({
            parameter: 'Overall Analysis',
            isHeader: true,
            ...data.reduce((acc, section) => ({
                ...acc,
                [section.sectionId]: ''
            }), {})
        });

        // Add Overall Analysis data rows
        parameters.forEach(param => {
            const row = {
                parameter: param,
                ...data.reduce((acc, section) => ({
                    ...acc,
                    [section.sectionId]: this.getValue(section, param)
                }), {})
            };
            processedData.push(row);
        });

        // Add marks range rows for Overall Analysis
        Object.keys(data[0].marksRangeCount).forEach(range => {
            const row = {
                parameter: this.formatRangeLabel(range),
                ...data.reduce((acc, section) => ({
                    ...acc,
                    [section.sectionId]: section.marksRangeCount[range]
                }), {})
            };
            processedData.push(row);
        });

        // Add Subject Analysis
        data[0].subjectAnalysis.forEach(subject => {
            // Add subject header row
            processedData.push({
                parameter: subject.subjectName,
                isHeader: true,
                ...data.reduce((acc, section) => ({
                    ...acc,
                    [section.sectionId]: ''
                }), {})
            });

            // Add subject data rows
            parameters.forEach(param => {
                const row = {
                    parameter: param,
                    ...data.reduce((acc, section) => {
                        // Use section data instead of subject data for Total Students and Present
                        const value = (param === 'Total No of Students' || param === 'Total Present') ?
                            this.getValue(section, param) :
                            this.getValue(section.subjectAnalysis.find(s => s.subjectName === subject.subjectName), param);
                        return {
                            ...acc,
                            [section.sectionId]: value
                        };
                    }, {})
                };
                processedData.push(row);
            });

            // Add marks range rows for subject
            Object.keys(subject.marksRangeCount).forEach(range => {
                const row = {
                    parameter: this.formatRangeLabel(range),
                    ...data.reduce((acc, section) => {
                        const subjectData = section.subjectAnalysis.find(s => s.subjectName === subject.subjectName);
                        return {
                            ...acc,
                            [section.sectionId]: subjectData.marksRangeCount[range]
                        };
                    }, {})
                };
                processedData.push(row);
            });
        });

        return { columns, data: processedData };
    }

    getValue(data, param) {
        switch (param) {
            case 'Total No of Students': return data.totalStudents;
            case 'Total Present': return data.presentCount;
            case 'Section Highest': return data.highestMarks || 0;
            case 'Section Least': return data.lowestMarks || 0;
            case 'Section Average': return data.averageMarks?.toFixed(2) || 0;
            default: return '';
        }
    }

    formatRangeLabel(range) {
        switch (range) {
            case 'lessThan0': return 'Less than 0';
            case 'range0To20': return '0 - 20';
            case 'range21To40': return '21 - 40';
            case 'range41To60': return '41 - 60';
            case 'range61To80': return '61 - 80';
            case 'range81To100': return '81 - 100';
            case 'range101To120': return '101 - 120';
            case 'range121To140': return '121 - 140';
            case 'range141To160': return '141 - 160';
            case 'range161To180': return '161 - 180';
            case 'range181To200': return '181 - 200';
            case 'range201To220': return '201 - 220';
            case 'range221To240': return '221 - 240';
            case 'range241To260': return '241 - 260';
            case 'range261To280': return '261 - 280';
            case 'range281To300': return '281 - 300';
            default: return range;
        }
    }

    onExamChange = (selectedExam) => {
        const filteredData = this.state.rawData.filter(item =>
            item.examId === selectedExam.examId
        );
        this.setState({
            selectedExam,
            filteredData,
            dataTableKey: this.state.dataTableKey + 1
        });
    };

    onViewAnalysis = () => {
        const { rawData, selectedExam } = this.state;
        if (!selectedExam) return;

        const filteredData = rawData.filter(item =>
            item.examId === selectedExam.examId
        );

        const processedData = this.processData(filteredData);
        this.setState({ filteredData: processedData });
    };

    render() {
        const {
            exams, selectedExam, selectedBranches, selectedSections,
            filteredData, dataTableKey, tableLoading, sectionsData
        } = this.state;
        const { branchData } = this.props;

        return (
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, padding: '0', marginLeft: "100px", marginTop: "55px", overflow: 'auto' }}>
                <div className="card filters-card mt-1 pt-0">
                    <div className="flex">
                        {/* Branches MultiSelect */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Branches <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetMultiSelect
                                    value={selectedBranches}
                                    options={branchData}
                                    onChange={(e) => this.onBranchesChange(e.value)}
                                    optionLabel="name"
                                    optionValue="key"
                                    placeholder="Select Branches"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                />
                            </div>
                        </div>

                        {/* Sections MultiSelect */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Grade -- Section <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetMultiSelect
                                    value={selectedSections}
                                    options={sectionsData}
                                    onChange={(e) => this.onSectionsChange(e.value)}
                                    optionLabel="name"
                                    optionValue="key"
                                    placeholder="Select Sections"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                    disabled={!selectedBranches.length}
                                />
                            </div>
                        </div>

                        {/* Exam Dropdown */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Exam <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    placeholder="Select Exam"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                    disabled={!selectedSections.length}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="grid m-2">
                        <div className="col-3 mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => {
                                    const exportColumns = [
                                        { field: 'parameter', header: 'Parameter' },
                                        ...filteredData.columns
                                    ];
                                    exportToExcel(filteredData.data, 'Section_Wise_Exam_Analysis_Report', exportColumns)
                                }}
                                disabled={!filteredData.data?.length}
                                className="p-button-secondary mr-2"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='datatable-report-demo mx-2'>
                    <DataTable
                        value={filteredData.data}
                        paginator
                        rows={50}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        className="p-datatable-custom"
                        loading={tableLoading}
                        rowClassName={rowData => rowData.isHeader ? 'header-row' : ''}
                        emptyMessage={
                            <div style={{ textAlign: 'center', padding: '1rem' }}>
                                No results found
                            </div>
                        }
                    >
                        <Column
                            field="parameter"
                            header=""
                            style={{ width: '200px', backgroundColor: '#f8f9fa' }}
                            frozen
                        />
                        {filteredData.columns?.map(col => (
                            <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                style={{ width: '150px' }}
                            />
                        ))}
                    </DataTable>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {tableLoading && <LoadingComponent />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    branchData: (state.branchDataLatest?.data?.data.filter((each) => each.level === 1)) || [],
    sectionsData: state.sectionsDataLatest?.data?.data || [],
});

export default connect(mapStateToProps, { getBranchesLatest })(withRouter(SectionWiseExamAnalysisReport));